import styles from './index.less'
import React, { Component } from 'react'
import loadError from '@/pages/images/common/loadError.png'
import { getStorage } from '@/utils/common'

/*
网络错误组件
*/
interface IProps {
  reload: any
  click?: (e: any) => void
  history: any
}

export default class NetworkError extends Component<IProps> {
  // public componentWillReceiveProps(nextProps: any) { }
  public reload = (param: any) => {
    // if (this.props.reload) {
    //     this.props.reload();
    // } else {
    //     window.location.reload();
    // }
    if (getStorage('pathName')) {
      location.href = getStorage('pathName')
    } else {
      window.location.reload()
    }
    console.log(this.props.history)
  }

  public render () {
    return (
      <div className={styles.noNetworkBox}>
        <div className={styles.emptyBox}>
          <img src={loadError} className={styles.emptyImg} />
          <div className={styles.text}>加载失败，请重新尝试</div>
          <button className={styles.loadBtn} onClick={this.reload}>
            重新加载
          </button>
        </div>
      </div>
    )
  }
}
